const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "Employee Name",
    dataIndex: "name",
    render: defaultRender,
  },
  {
    title: "Email",
    dataIndex: "email",
    render: defaultRender,
  },
  {
    title: "Contact",
    dataIndex: "contact_no",
    render: defaultRender,
  },
  {
    title: "Rate",
    dataIndex: "rate",
    render: defaultRender,
  },
  {
    title: "SIN no.",
    dataIndex: "sin_no",
    render: defaultRender,
  },
  {
    title: "DOB",
    dataIndex: "dob",
    render: defaultRender,
  },
  {
    title: "Joining date",
    dataIndex: "joining_date",
    render: defaultRender,
  },
    {
    title: "EI Exemption",
    dataIndex: "exemption",
    render: defaultRender,
  },
  {
    title: "Address",
    dataIndex: "address",
    render: defaultRender,
    width: 100,
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    render: defaultRender,
  },

  {
    title: "Action",
    dataIndex: "action",
    render: defaultRender,
  },
];

export default columns;
